import { is } from 'ramda';

const ANONYMOUS_USER_ID = 'anonymous';

class LocalStorage {
  #userId = ANONYMOUS_USER_ID;

  setUser = (id) => {
    this.#userId = id;
  };

  reset = () => {
    this.#userId = ANONYMOUS_USER_ID;
  };

  #setItem = (namespace, key, value) => {
    const preparedValue = is(String, value) ? value : JSON.stringify(value);
    const name = namespace ? `${namespace}:${key}` : key;
    window.localStorage.setItem(name, preparedValue);
  };

  #getItem = (namespace, key, transform = JSON.parse) => {
    const name = namespace ? `${namespace}:${key}` : key;
    const value = window.localStorage.getItem(name);
    try {
      return transform(value);
    } catch (error) {
      return value;
    }
  };

  #removeItem = (namespace, key) => {
    const name = namespace ? `${namespace}:${key}` : key;
    window.localStorage.removeItem(name);
  };

  getKeyInUserNameSpace = (key) => (this.#userId ? `${this.#userId}:${key}` : key);

  setUserItem = (key, value) => this.#setItem(this.#userId, key, value);

  getUserItem = (key, transform) => this.#getItem(this.#userId, key, transform);

  removeUserItem = (key) => this.#removeItem(this.#userId, key);

  setItem = (key, value) => this.#setItem(undefined, key, value);

  getItem = (key, transform) => this.#getItem(undefined, key, transform);

  removeItem = (key) => this.#removeItem(undefined, key);
}

export default new LocalStorage();
